import * as React from "react";
import { ProgressProps } from "webapp/ui/views/progress-indicator/progress-indicator-types";
import { styled } from "webapp/styled-components";
import CircleProgressView from "webapp/ui/views/progress-indicator/circle-progress/circle-progress-view";
import HalfCircleProgressView from "webapp/ui/views/progress-indicator/half-circle-progress/half-circle-progress-view";
import ProgressIndicatorView from "webapp/ui/views/progress-indicator/bar-progress/progress-indicator-view";

interface Props extends ProgressProps {
    readonly style: "bar" | "circle" | "half-circle";
}

const ProgressIndicatorStyle = styled.div`
    padding: ${p => p.theme.componentSmallInnerVerticalPadding}px 0;
`;

const ProgressIndicatorImpl: React.FunctionComponent<Props> = p => {
    const { style, ...rest } = p;
    let content: React.ReactNode;

    switch (style) {
        case "circle":
            content = <CircleProgressView {...rest} />;
            break;

        case "half-circle":
            content = <HalfCircleProgressView {...rest} />;
            break;

        case "bar":
        default:
            content = <ProgressIndicatorView {...rest} />;
    }
    return <ProgressIndicatorStyle>{content}</ProgressIndicatorStyle>;
};

const ProgressIndicator = ProgressIndicatorImpl;
export default ProgressIndicator;
